module.exports = __webpack_public_path__ + "static/media/moose.da129c34.svg";